<template>
    <section :id="`element-${settings.id}`" :class="classes">
        <div class="elle-instructions--wrapper" :style="{ backgroundColor: settings?.color }">
            <div class="grid12">
                <div class="l-col">
                    <UiHeadline
                        :settings="{
                            label: settings?.label,
                            headline: settings?.headline
                        }"
                    >
                        <template #additional>
                            <div v-if="settings?.description" class="content typography" v-html="props.settings?.description" />
                            <div v-if="settings?.linkUrl.length" class="buttons">
                                <UiLink :link="settings?.linkUrl[0]" :style="'transparent w-border'" />
                            </div>
                        </template>
                    </UiHeadline>
                </div>
                <div class="r-col">
                    <LoopsInstructions :instructions="settings?.instructionItems" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});

const classes = computed(() => (props.settings?.wrapped ? 'elle-instructions wrapped' : 'elle-instructions'));
</script>
